__turbopack_context__.v({
  "notifications-dialog": "notifications-modal-trigger-module-scss-module__xpJcuW__notifications-dialog",
  "notifications-dialog__content": "notifications-modal-trigger-module-scss-module__xpJcuW__notifications-dialog__content",
  "notifications-dialog__header": "notifications-modal-trigger-module-scss-module__xpJcuW__notifications-dialog__header",
  "notifications-modal-container": "notifications-modal-trigger-module-scss-module__xpJcuW__notifications-modal-container",
});
